import { getPrintData, listTemplateByCompanyStoreIdAndType } from "@/utils/api"
export const printdata = {
    data() {
        return {

        }
    },
    methods: {
        getPrintList() {
            let params = {}
            let header = {}
            let data = {
                companyStoreId: this.$store.state.userInfo.companyStoreId,
                templateType: this.templateType
            }
            this.formData = {
                printTitle: {},
                topArray: [],
                columns: [],
                dataSource: [],
                bottonArray: [],
                footerArry: [],
                custom: {}
            }
            listTemplateByCompanyStoreIdAndType(params, header, data).then((res) => {
                if (res.code == 200) {
                    this.formData = JSON.parse(res.result[0].content)
                    this.resetData = JSON.parse(res.result.pop().content)
                    if (res.result.length >= 1) {
                        this.isEditPrintid = true
                        this.editPrintid = res.result[0].id
                    }
                    this.getData()
                } else {
                    this.$message.error(res.logMessage)
                }
            })
        },
        getData() {
            let header = {}
            let data = {
                companyStoreId: this.$store.state.userInfo.companyStoreId,
            }
            let paramsDetails = new FormData()
            let url = ''
            if (this.templateType == 101) {
                url = '/storage/api/outbound/findOutboundById'
                data.id = this.orderId
            } else if (this.templateType == 102) {
                url = '/order/api/salesPrice/findSalesPriceById'
                paramsDetails.append("salesPriceId", this.orderId)
            } else if (this.templateType == 103) {
                url = '/order/api/salesOrder/findSalesOrderById'
                paramsDetails.append("salesOrderId", this.orderId)
            } else if (this.templateType == 104) {
                url = '/storage/api/inbound/findInboundById'
                data.id = this.orderId
            } else if (this.templateType == 201) {
                url = '/storage/api/inbound/findInboundById'
                data.id = this.orderId
            } else if (this.templateType == 202) {
                url = '/storage/api/outbound/findOutboundById'
                data.id = this.orderId
            } else if (this.templateType == 203) {
                url = '/order/api/purchaseInquiryPrice/purchaseInquiryPriceInfo'
                paramsDetails.append("id", this.orderId)
            } else if (this.templateType == 204) {
                url = '/order/api/purchaseOrder/findPurchaseOrderItemById'
                paramsDetails.append("id", this.orderId)
            } else if (this.templateType == 501) {
                url = '/report/api/reportHistoryStockBalance/pageByConditions'
                data = {
                    ageNo: 1,
                    pageSize: this.total,
                }
                if (this.startTime != undefined) {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                        endTime: this.endTime,
                        startTime: this.startTime
                    }
                } else {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                    }
                }
            } else if (this.templateType == 502) {
                let obj = JSON.parse(sessionStorage.getItem("comeWarehouseReport"))
                url = '/report/api/reportStorageOutbound/listByConditions'
                data = {
                    ageNo: 1,
                    pageSize: this.total,
                }
                if (this.startTime != undefined) {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                        endTime: this.endTime,
                        startTime: this.startTime,
                        keyWord: obj.keyWord,
                        contactCustomerId: obj.contactCustomerId,
                        outboundType: obj.outboundType,
                        storageId: obj.storageId
                    }
                } else {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                        keyWord: obj.keyWord,
                        contactCustomerId: obj.contactCustomerId,
                        outboundType: obj.outboundType,
                        storageId: obj.storageId
                    }
                }
            } else if (this.templateType == 503) {
                let obj = JSON.parse(sessionStorage.getItem("enterWarehouseReport"))
                url = '/report/api/reportStorageInbound/listByConditions'
                data = {
                    ageNo: 1,
                    pageSize: this.total,
                }
                if (this.startTime != undefined) {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                        endTime: this.endTime,
                        startTime: this.startTime,
                        keyWord: obj.keyWord,
                        contactCustomerId: obj.contactCustomerId,
                        outboundType: obj.outboundType,
                        storageId: obj.storageId
                    }
                } else {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                        keyWord: obj.keyWord,
                        contactCustomerId: obj.contactCustomerId,
                        outboundType: obj.outboundType,
                        storageId: obj.storageId
                    }
                }
            } else if (this.templateType == 50401) {
                let obj = JSON.parse(sessionStorage.getItem("sellReport"))
                url = '/report/api/reportSales/pageSalesProductListByCondition'
                data = {
                    ageNo: 1,
                    pageSize: this.total,
                }
                if (this.startTime != undefined) {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                        endDate: this.endTime,
                        startDate: this.startTime,
                        categoryId1: obj.categoryId1,
                        categoryId2: obj.categoryId2,
                        categoryId3: obj.categoryId3,
                        keywords: obj.keywords,
                    }
                } else {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                        keyWord: obj.keyWord,
                        contactCustomerId: obj.contactCustomerId,
                        outboundType: obj.outboundType,
                        storageId: obj.storageId
                    }
                }
            } else if (this.templateType == 50402) {
                let obj = JSON.parse(sessionStorage.getItem("sellReport"))
                url = '/report/api/reportSales/pageSalesContactCustomerListByCondition'
                data = {
                    ageNo: 1,
                    pageSize: this.total,
                }
                if (this.startTime != undefined) {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                        endDate: this.endTime,
                        startDate: this.startTime,
                        contactCustomerCategoryId: obj.contactCustomerCategoryId,
                        keywords: obj.keywords,
                    }
                } else {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                        keyWord: obj.keyWord,
                        contactCustomerId: obj.contactCustomerId,
                        outboundType: obj.outboundType,
                        storageId: obj.storageId
                    }
                }
            } else if (this.templateType == 50403) {
                let obj = JSON.parse(sessionStorage.getItem("sellReport"))
                url = '/report/api/reportSales/pageSalesTransactorListByCondition'
                data = {
                    ageNo: 1,
                    pageSize: this.total,
                }
                if (this.startTime != undefined) {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                        endDate: this.endTime,
                        startDate: this.startTime,
                        keywords: obj.keywords,
                    }
                } else {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                        keyWord: obj.keyWord,
                        contactCustomerId: obj.contactCustomerId,
                        outboundType: obj.outboundType,
                        storageId: obj.storageId
                    }
                }
            } else if (this.templateType == 50501) {
                let obj = JSON.parse(sessionStorage.getItem("purchaseReport"))
                url = '/report/api/reportPurchase/pagePurchaseProductListByCondition'
                data = {
                    ageNo: 1,
                    pageSize: this.total,
                }
                if (this.startTime != undefined) {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                        endDate: this.endTime,
                        startDate: this.startTime,
                        categoryId1: obj.categoryId1,
                        categoryId2: obj.categoryId2,
                        categoryId3: obj.categoryId3,
                        keywords: obj.keywords,
                    }
                } else {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                        keyWord: obj.keyWord,
                        contactCustomerId: obj.contactCustomerId,
                        outboundType: obj.outboundType,
                        storageId: obj.storageId
                    }
                }
            } else if (this.templateType == 50502) {
                let obj = JSON.parse(sessionStorage.getItem("purchaseReport"))
                url = '/report/api/reportPurchase/pagePurchaseContactCustomerListByCondition'
                data = {
                    ageNo: 1,
                    pageSize: this.total,
                }
                if (this.startTime != undefined) {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                        endDate: this.endTime,
                        startDate: this.startTime,
                        contactCustomerCategoryId: obj.contactCustomerCategoryId,
                        keywords: obj.keywords,
                    }
                } else {
                    paramsDetails = {
                        companyId: this.$store.state.userInfo.companyId,
                        companyStoreId: this.$store.state.userInfo.companyStoreId,
                        keyWord: obj.keyWord,
                        contactCustomerId: obj.contactCustomerId,
                        outboundType: obj.outboundType,
                        storageId: obj.storageId
                    }
                }
            } else if (this.templateType == 506) {
                url = '/finance/api/financeIncomeStatement/listFinanceIncomeStatement'
                data = {
                    companyStoreId: this.$store.state.userInfo.companyStoreId,
                }
            } else if (this.templateType == 401) {
                data = {
                    companyStoreId: this.$store.state.userInfo.companyStoreId,
                    id: this.orderId
                }
                url = '/storage/api/storageAllocate/findStorageAllocateById'
                data = {
                    companyStoreId: this.$store.state.userInfo.companyStoreId,
                    id:this.orderId
                }
                // paramsDetails.append("id", this.orderId)
            } else if (this.templateType == 402) {
                url = '/storage/api/outbound/findOutboundById'
                paramsDetails.append("id", this.orderId)
            } else if (this.templateType == 403) {
                url = '/storage/api/inbound/findInboundById'
                paramsDetails.append("id", this.orderId)
            } else if (this.templateType == 405) {
                url = '/storage/api/inbound/findInboundById'
                paramsDetails.append("id", this.orderId)
            } else if (this.templateType == 406) {
                url = '/storage/api/outbound/findOutboundById'
                paramsDetails.append("id", this.orderId)
            } else if (this.templateType == 301) {
                url = '/finance/api/financeOtherExpenditure/findFinanceOtherExpenditureInfo'
                paramsDetails.append("id", this.orderId)
            } else if (this.templateType == 302) {
                url = '/finance/api/financeOtherIncome/findOtherIncomeById'
                data.otherIncomeId = this.orderId
            } else if (this.templateType == 303) {
                url = '/finance/api/financeCollectionOrder/findCollectionOrderById'
                data.collectionOrderId = this.orderId
            } else if (this.templateType == 304) {
                url = '/finance/api/financePaymentOrder/findPaymentOrderInfo'
                data.financePaymentId = this.orderId
            } else if (this.templateType == 407) {
                url = '/storage/api/combind/findCombindById'
                data.id = this.orderId
            }
            getPrintData(url, paramsDetails, header, data).then((res) => {
                if (res.code == 200) {
                    if (this.templateType == 101) {
                        this.setbillMarket(res.result)
                    } else if (this.templateType == 102) {
                        this.setmakeOffers(res.result)
                    } else if (this.templateType == 103) {
                        this.setsellOrderLook(res.result)
                    } else if (this.templateType == 104) {
                        this.setbillMarketReturn(res.result)
                    } else if (this.templateType == 201) {
                        this.setbillPurchase(res.result)
                    } else if (this.templateType == 202) {
                        this.setbillPurchaseReturn(res.result)
                    } else if (this.templateType == 203) {
                        this.setenquiryLook(res.result)
                    } else if (this.templateType == 204) {
                        this.setpurchaseOrderLook(res.result)
                    } else if (this.templateType == 501) {
                        this.setinventoryReport(res.result)
                    } else if (this.templateType == 502) {
                        this.setcomeWarehouseReport(res.result)
                    } else if (this.templateType == 503) {
                        this.setenterWarehouseReport(res.result)
                    } else if (this.templateType == 50401) {
                        this.setsellReport(res.result)
                    } else if (this.templateType == 50402) {
                        this.setsellReport(res.result)
                    } else if (this.templateType == 50403) {
                        this.setsellReport(res.result)
                    } else if (this.templateType == 50501) {
                        this.setpurchaseReport(res.result)
                    } else if (this.templateType == 50502) {
                        this.setpurchaseReport(res.result)
                    } else if (this.templateType == 506) {
                        this.setprofit(res.result)
                    } else if (this.templateType == 401) {
                        this.setwarehouse(res.result)
                    } else if (this.templateType == 402) {
                        this.setwareloss(res.result)
                    } else if (this.templateType == 403) {
                        this.setwareover(res.result)
                    } else if (this.templateType == 405) {
                        this.setwareover(res.result)
                    } else if (this.templateType == 406) {
                        this.setwareloss(res.result)
                    } else if (this.templateType == 301) {
                        this.setotherorder(res.result)
                    } else if (this.templateType == 302) {
                        this.setothershouorder(res.result)
                    } else if (this.templateType == 303) {
                        this.setshouorder(res.result)
                    } else if (this.templateType == 304) {
                        this.setfuorder(res.result)
                    } else if (this.templateType == 407) {
                        this.setassembly(res.result)
                    }
                } else {
                    this.$message.error(res.logMessage)
                }
            })
        },
        // 销售出库
        setbillMarket(data) {
            this.formData.topArray.map((item, index) => {
                if (item.name == 'outboundDate') {
                    item.value = data.outboundDate
                } else if (item.name == 'outboundCode') {
                    item.value = data.outboundCode
                } else if (item.name == 'transactorName') {
                    item.value = data.transactorName
                } else if (item.name == 'contactCustomerName') {
                    item.value = data.contactCustomerName
                } else if (item.name == 'storageName') {
                    item.value = data.storageName
                } else if (item.name == 'remark') {
                    item.value = data.remark
                }
            })
            this.formData.bottonArray.map((item, index) => {
                if (item.name == 'includeFreightFlag') {
                    item.value = data.includeFreightFlag==1? '含运费' :'不含运费'
                } else if (item.name == 'otherExpensesAmount') {
                    item.value = data.otherExpensesAmount? '¥ '+data.otherExpensesAmount :'¥ 0'
                } else if (item.name == 'discountAmount') {
                    item.value = data.discountAmount? '¥ '+data.discountAmount :'¥ 0'
                } else if (item.name == 'totalAmount') {
                    item.value = data.totalAmount? '¥ '+data.totalAmount :'¥ 0'
                } else if (item.name == 'distributionMode') {
                    item.value = data.distributionMode == 1 ? '客户自提' : '送货上门'
                } else if (item.name == 'logisticsCompanyName') {
                    item.value = data.logisticsCompanyName
                } else if (item.name == 'amountName') {
                    if (data.paymentAccountVOList.length > 0 && data.paymentAccountVOList.length <= 1) {
                        item.value = data.paymentAccountVOList[0].financeAccountName
                    } else if (data.paymentAccountVOList.length > 1) {
                        item.value = '多账户'
                    } else {
                        item.value = '-'
                    }
                } else if (item.name == 'nowPaymentAmount') {
                    item.value = data.nowPaymentAmount? '¥ '+data.nowPaymentAmount :'¥ 0'
                } else if (item.name == 'noPayAmount') {
                    item.value = '¥ ' + (data.totalAmount?data.totalAmount :0 - data.nowPaymentAmount?data.nowPaymentAmount :0)
                }
            })
            let totalAmount = 0
            let productCount = 0
            this.formData.dataSource = []
            data.itemList.map(item => {
                totalAmount += item.totalAmount
                productCount += item.productCount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                productCode: '合计',
                totalAmount: totalAmount.toFixed(2),
                productCount: productCount
            })
        },
        // 销售报价
        setmakeOffers(data) {
            this.formData.topArray.map(item => {
                if (item.name == 'voucherDate') {
                    item.value = data.voucherDate
                } else if (item.name == 'code') {
                    item.value = data.code
                } else if (item.name == 'transactorName') {
                    item.value = data.transactorName
                } else if (item.name == 'contactCustomerName') {
                    item.value = data.contactCustomerName
                } else if (item.name == 'outStorageName') {
                    item.value = data.outStorageName
                } else if (item.name == 'remark') {
                    item.value = data.remark
                }
            })
            this.formData.bottonArray.map(item => {
                if (item.name == 'includeFreightFlag') {
                    item.value = data.includeFreightFlag==1? '含运费' :'不含运费'
                } else if (item.name == 'otherExpensesAmount') {
                    item.value = data.otherExpensesAmount? '¥ '+data.otherExpensesAmount :'¥ 0'
                } else if (item.name == 'discountAmount') {
                    item.value = data.discountAmount? '¥ '+data.discountAmount :'¥ 0'
                } else if (item.name == 'totalAmount') {
                    item.value = data.totalAmount? '¥ '+data.totalAmount :'¥ 0'
                } else if (item.name == 'distributionMode') {
                    item.value = data.distributionMode == 1 ? '客户自提' : '送货上门'
                } else if (item.name == 'logisticsCompanyName') {
                    item.value = data.logisticsCompanyName
                }
            })
            let totalAmount = 0
            let productTotalCount = 0
            this.formData.dataSource = []
            data.salesPriceItemVOList.map(item => {
                totalAmount += item.totalAmount
                productTotalCount += item.productTotalCount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                productCode: '合计',
                totalAmount: totalAmount.toFixed(2),
                productTotalCount: productTotalCount
            })
        },
        // 销售订单
        setsellOrderLook(data) {
            this.formData.topArray.map(item => {
                if (item.name == 'voucherDate') {
                    item.value = data.voucherDate
                } else if (item.name == 'code') {
                    item.value = data.code
                } else if (item.name == 'transactorName') {
                    item.value = data.transactorName
                } else if (item.name == 'contactCustomerName') {
                    item.value = data.contactCustomerName
                } else if (item.name == 'outStorageName') {
                    item.value = data.outStorageName
                } else if (item.name == 'remark') {
                    item.value = data.remark
                }
            })
            this.formData.bottonArray.map((item, index) => {
                if (item.name == 'otherExpensesAmount') {
                    item.value = data.otherExpensesAmount? '¥ '+data.otherExpensesAmount :'¥ 0'
                } else if (item.name == 'discountAmount') {
                    item.value = data.discountAmount? '¥ '+data.discountAmount :'¥ 0'
                } else if (item.name == 'totalAmount') {
                    item.value = data.totalAmount? '¥ '+data.totalAmount :'¥ 0'
                } else if (item.name == 'distributionMode') {
                    item.value = data.distributionMode == 1 ? '客户自提' : '送货上门'
                } else if (item.name == 'logisticsCompanyName') {
                    if (data.distributionMode == 1) {
                        this.formData.bottonArray.splice(index, 1)
                    } else {
                        item.value = data.logisticsCompanyName
                    }
                }
            })
            let totalAmount = 0
            let productTotalCount = 0
            this.formData.dataSource = []
            data.salesOrderItemVOList.map(item => {
                totalAmount += item.totalAmount
                productTotalCount += item.productTotalCount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                productCode: '合计',
                totalAmount: totalAmount.toFixed(2),
                productTotalCount: productTotalCount
            })
        },
        // 销售退货但
        setbillMarketReturn(data) {
            this.formData.topArray.map((item, index) => {
                if (item.name == 'inboundDate') {
                    item.value = data.inboundDate
                } else if (item.name == 'inboundCode') {
                    item.value = data.inboundCode
                } else if (item.name == 'transactorName') {
                    item.value = data.transactorName
                } else if (item.name == 'contactCustomerName') {
                    item.value = data.contactCustomerName
                } else if (item.name == 'storageName') {
                    item.value = data.storageName
                } else if (item.name == 'remark') {
                    item.value = data.remark
                }
            })
            this.formData.bottonArray.map((item, index) => {
                if (item.name == 'otherExpensesAmount') {
                    item.value = data.otherExpensesAmount? '¥ '+data.otherExpensesAmount :'¥ 0'
                } else if (item.name == 'discountAmount') {
                    item.value = data.discountAmount? '¥ '+data.discountAmount :'¥ 0'
                } else if (item.name == 'totalAmount') {
                    item.value = data.totalAmount? '¥ '+data.totalAmount :'¥ 0'
                } else if (item.name == 'distributionMode') {
                    item.value = data.distributionMode == 1 ? '客户自提' : '送货上门'
                } else if (item.name == 'logisticsCompanyName') {
                    item.value = data.logisticsCompanyName
                } else if (item.name == 'amountName') {
                    if (data.paymentAccountVOList.length > 0 && data.paymentAccountVOList.length <= 1) {
                        item.value = data.paymentAccountVOList[0].financeAccountName
                    } else if (data.paymentAccountVOList.length > 1) {
                        item.value = '多账户'
                    } else {
                        item.value = '-'
                    }
                } else if (item.name == 'nowPaymentAmount') {
                    item.value = data.nowPaymentAmount? '¥ '+data.nowPaymentAmount :'¥ 0'
                } else if (item.name == 'noPayAmount') {
                    item.value = '¥ '+(data.totalAmount? data.totalAmount :0 - data.nowPaymentAmount? data.nowPaymentAmount :0)
                }
            })
            let totalAmount = 0
            let productTotalCount = 0
            this.formData.dataSource = []
            data.itemList.map(item => {
                totalAmount += item.totalAmount
                productTotalCount += item.productTotalCount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                productCode: '合计',
                totalAmount: totalAmount.toFixed(2),
                productTotalCount: productTotalCount
            })
        },
        // 采购入库
        setbillPurchase(data) {
            this.formData.topArray.map((item, index) => {
                if (item.name == 'inboundDate') {
                    item.value = data.inboundDate
                } else if (item.name == 'inboundCode') {
                    item.value = data.inboundCode
                } else if (item.name == 'transactorName') {
                    item.value = data.transactorName
                } else if (item.name == 'contactCustomerName') {
                    item.value = data.contactCustomerName
                } else if (item.name == 'storageName') {
                    item.value = data.storageName
                } else if (item.name == 'remark') {
                    item.value = data.remark
                }
            })
            this.formData.bottonArray.map((item, index) => {
                if (item.name == 'otherExpensesAmount') {
                    item.value = data.otherExpensesAmount? '¥ '+data.otherExpensesAmount :'¥ 0'
                } else if (item.name == 'discountAmount') {
                    item.value = data.discountAmount? '¥ '+data.discountAmount :'¥ 0'
                } else if (item.name == 'totalAmount') {
                    item.value = data.totalAmount? '¥ '+data.totalAmount :'¥ 0'
                } else if (item.name == 'distributionMode') {
                    item.value = data.distributionMode == 1 ? '客户自提' : '送货上门'
                } else if (item.name == 'logisticsCompanyName') {
                    item.value = data.logisticsCompanyName
                } else if (item.name == 'amountName') {
                    if (data.paymentAccountVOList.length > 0 && data.paymentAccountVOList.length <= 1) {
                        item.value = data.paymentAccountVOList[0].financeAccountName
                    } else if (data.paymentAccountVOList.length > 1) {
                        item.value = '多账户'
                    } else {
                        item.value = '-'
                    }
                } else if (item.name == 'nowPaymentAmount') {
                    item.value = data.nowPaymentAmount? '¥ '+data.nowPaymentAmount :'¥ 0'
                } else if (item.name == 'noPayAmount') {
                    item.value = '¥ '+(data.totalAmount? data.totalAmount :0 - data.nowPaymentAmount? data.nowPaymentAmount :0)
                }
            })
            let totalAmount = 0
            let productCount = 0
            this.formData.dataSource = []
            data.itemList.map(item => {
                totalAmount += item.totalAmount
                productCount += item.productCount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                productCode: '合计',
                totalAmount: totalAmount.toFixed(2),
                productCount: productCount
            })
        },
        // 采购退货
        setbillPurchaseReturn(data) {
            this.formData.topArray.map((item, index) => {
                if (item.name == 'outboundDate') {
                    item.value = data.outboundDate
                } else if (item.name == 'outboundCode') {
                    item.value = data.outboundCode
                } else if (item.name == 'transactorName') {
                    item.value = data.transactorName
                } else if (item.name == 'contactCustomerName') {
                    item.value = data.contactCustomerName
                } else if (item.name == 'storageName') {
                    item.value = data.storageName
                } else if (item.name == 'remark') {
                    item.value = data.remark
                }
            })
            this.formData.bottonArray.map((item, index) => {
                if (item.name == 'otherExpensesAmount') {
                    item.value = data.otherExpensesAmount? '¥ '+data.otherExpensesAmount :'¥ 0'
                } else if (item.name == 'discountAmount') {
                    item.value = data.discountAmount? '¥ '+data.discountAmount :'¥ 0'
                } else if (item.name == 'totalAmount') {
                    item.value = data.totalAmount? '¥ '+data.totalAmount :'¥ 0'
                } else if (item.name == 'distributionMode') {
                    item.value = data.distributionMode == 1 ? '客户自提' : '送货上门'
                } else if (item.name == 'logisticsCompanyName') {
                    item.value = data.logisticsCompanyName
                } else if (item.name == 'amountName') {
                    if (data.paymentAccountVOList.length > 0 && data.paymentAccountVOList.length <= 1) {
                        item.value = data.paymentAccountVOList[0].financeAccountName
                    } else if (data.paymentAccountVOList.length > 1) {
                        item.value = '多账户'
                    } else {
                        item.value = '-'
                    }
                } else if (item.name == 'nowPaymentAmount') {
                    item.value = data.nowPaymentAmount? '¥ '+data.nowPaymentAmount :'¥ 0'
                } else if (item.name == 'noPayAmount') {
                    item.value = '¥ '+(data.totalAmount? data.totalAmount :0 - data.nowPaymentAmount? data.nowPaymentAmount :0)
                }
            })
            let totalAmount = 0
            let productCount = 0
            this.formData.dataSource = []
            data.itemList.map(item => {
                totalAmount += item.totalAmount
                productCount += item.productCount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                productCode: '合计',
                totalAmount: totalAmount.toFixed(2),
                productCount: productCount
            })
        },
        // 采购询价
        setenquiryLook(data) {
            this.formData.topArray.map((item, index) => {
                if (item.name == 'purchaseVoucherDate') {
                    item.value = data.purchaseInquiryPriceVO.purchaseVoucherDate
                } else if (item.name == 'code') {
                    item.value = data.purchaseInquiryPriceVO.code
                } else if (item.name == 'transactorName') {
                    item.value = data.purchaseInquiryPriceVO.transactorName
                } else if (item.name == 'contactCustomerName') {
                    item.value = data.purchaseInquiryPriceVO.contactCustomerName
                } else if (item.name == 'inStorageName') {
                    item.value = data.purchaseInquiryPriceVO.inStorageName
                } else if (item.name == 'remark') {
                    item.value = data.purchaseInquiryPriceVO.remark
                }
            })
            let planAmount = 0
            let planNumber = 0
            this.formData.dataSource = []
            data.purchaseInquiryPriceItemsVO.map(item => {
                planAmount += item.planAmount
                planNumber += item.planNumber
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                productCode: '合计',
                planAmount: planAmount.toFixed(2),
                planNumber: planNumber
            })
        },
        // 采购订单
        setpurchaseOrderLook(data) {
            this.formData.topArray.map((item, index) => {
                if (item.name == 'orderDate') {
                    item.value = data.purchaseOrderVo.orderDate
                } else if (item.name == 'code') {
                    item.value = data.purchaseOrderVo.code
                } else if (item.name == 'transactorName') {
                    item.value = data.purchaseOrderVo.transactorName
                } else if (item.name == 'contactCustomerName') {
                    item.value = data.purchaseOrderVo.contactCustomerName
                } else if (item.name == 'inStorageName') {
                    item.value = data.purchaseOrderVo.inStorageName
                } else if (item.name == 'remark') {
                    item.value = data.purchaseOrderVo.remark
                }
            })
            let totalAmount = 0
            let productTotalCount = 0
            this.formData.dataSource = []
            data.purchaseOrderItemVOList.map(item => {
                item.totalAmount = item.productTotalAmount
                totalAmount += item.totalAmount
                productTotalCount += item.productTotalCount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                productCode: '合计',
                totalAmount: totalAmount.toFixed(2),
                productTotalCount: productTotalCount
            })
        },
        // 库存余额
        setinventoryReport(data) {
            this.formData.topArray.map((item, index) => {
                if (item.name == 'endTime') {
                    if (this.endTime != undefined) {
                        item.value = this.endTime
                    } else {
                        item.value = '-'
                    }
                } else if (item.name == 'startTime') {
                    if (this.startTime != undefined) {
                        item.value = this.startTime
                    } else {
                        item.value = '-'
                    }
                }
            })
            let stockAmount = 0
            let stockCount = 0
            this.formData.dataSource = []
            data.records.map(item => {
                stockAmount += item.stockAmount
                stockCount += item.stockCount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                date: '合计',
                stockAmount: stockAmount.toFixed(2),
                stockCount: stockCount
            })
        },
        // 出库报表
        setcomeWarehouseReport(data) {
            let obj = JSON.parse(sessionStorage.getItem("comeWarehouseReport"))
            this.formData.topArray.map((item, index) => {
                if (item.name == 'typeName') {
                    if (obj.typeName) {
                        item.value = obj.typeName
                    } else {
                        item.value = '-'
                    }
                } else if (item.name == 'storageName') {
                    if (obj.storageName) {
                        item.value = obj.storageName
                    } else {
                        item.value = '-'
                    }
                } else if (item.name == 'date') {
                    if (this.endTime != undefined) {
                        item.value = this.startTime + ' 至 ' + this.endTime
                    } else {
                        item.value = ''
                    }
                }
            })
            this.formData.topArray.map((item, index) => {
                if (item.name == 'date') {
                    if (item.value == '') {
                        this.formData.topArray.splice(index, 1)
                    }
                }
            })
            let totalAmount = 0
            let stockCount = 0
            this.formData.dataSource = []
            data.records.map(item => {
                totalAmount += item.totalAmount
                stockCount += item.stockCount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                date: '合计',
                totalAmount: totalAmount.toFixed(2),
                stockCount: stockCount
            })
        },
        // 采购报表
        setenterWarehouseReport(data) {
            let obj = JSON.parse(sessionStorage.getItem("enterWarehouseReport"))
            this.formData.topArray.map((item, index) => {
                if (item.name == 'typeName') {
                    if (obj.typeName) {
                        item.value = obj.typeName
                    } else {
                        item.value = '-'
                    }
                } else if (item.name == 'storageName') {
                    if (obj.storageName) {
                        item.value = obj.storageName
                    } else {
                        item.value = '-'
                    }
                } else if (item.name == 'date') {
                    if (this.endTime != undefined) {
                        item.value = this.startTime + ' 至 ' + this.endTime
                    } else {
                        item.value = ''
                    }
                }
            })
            this.formData.topArray.map((item, index) => {
                if (item.name == 'date') {
                    if (item.value == '') {
                        this.formData.topArray.splice(index, 1)
                    }
                }
            })
            let totalAmount = 0
            let stockCount = 0
            this.formData.dataSource = []
            data.records.map(item => {
                totalAmount += item.totalAmount
                stockCount += item.stockCount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                date: '合计',
                totalAmount: totalAmount.toFixed(2),
                stockCount: stockCount
            })
        },
        // 销售报表
        setsellReport(data) {
            let obj = JSON.parse(sessionStorage.getItem("sellReport"))
            if (obj.type == 1) {
                this.formData.topArray.map((item, index) => {
                    if (item.name == 'date') {
                        if (this.endTime) {
                            item.value = this.startTime + ' 至 ' + this.endTime
                        } else {
                            item.value = ''
                        }
                    }
                })
                this.formData.topArray.map((item, index) => {
                    if (item.name == 'date') {
                        if (item.value == '') {
                            this.formData.topArray.splice(index, 1)
                        }
                    }
                })
                let totalAmount = 0
                let salesCount = 0
                this.formData.dataSource = []
                data.records.map(item => {
                    totalAmount += item.totalAmount
                    salesCount += item.salesCount
                    this.formData.dataSource.push(item)
                })
                this.formData.dataSource.push({
                    date: '合计',
                    totalAmount: totalAmount.toFixed(2),
                    salesCount: salesCount
                })
            } else if (obj.type == 2) {
                this.formData.topArray.map((item, index) => {
                    if (item.name == 'date') {
                        if (this.endTime != undefined) {
                            item.value = this.startTime + ' 至 ' + this.endTime
                        } else {
                            item.value = ''
                        }
                    }
                })
                this.formData.topArray.map((item, index) => {
                    if (item.name == 'date') {
                        if (item.value == '') {
                            this.formData.topArray.splice(index, 1)
                        }
                    }
                })
                let totalAmount = 0
                let salesCount = 0
                this.formData.dataSource = []
                data.records.map(item => {
                    totalAmount += item.totalAmount
                    salesCount += Number(item.salesCount)
                    this.formData.dataSource.push(item)
                })
                this.formData.dataSource.push({
                    date: '合计',
                    totalAmount: totalAmount.toFixed(2),
                    salesCount: salesCount
                })
            } else if (obj.type == 3) {
                this.formData.topArray.map((item, index) => {
                    if (item.name == 'date') {
                        if (this.endTime != undefined) {
                            item.value = this.startTime + ' 至 ' + this.endTime
                        } else {
                            item.value = ''
                        }
                    }
                })
                this.formData.topArray.map((item, index) => {
                    if (item.name == 'date') {
                        if (item.value == '') {
                            this.formData.topArray.splice(index, 1)
                        }
                    }
                })
                let dealTotalAmount = 0
                let dealCount = 0
                this.formData.dataSource = []
                data.records.map(item => {
                    dealTotalAmount += item.dealTotalAmount
                    dealCount += Number(item.dealCount)
                    this.formData.dataSource.push(item)
                })
                this.formData.dataSource.push({
                    date: '合计',
                    dealTotalAmount: dealTotalAmount.toFixed(2),
                    dealCount: dealCount
                })
            }
        },
        // 采购报表
        setpurchaseReport(data) {
            let obj = JSON.parse(sessionStorage.getItem("purchaseReport"))
            if (obj.type == 1) {
                this.formData.topArray.map((item, index) => {
                    if (item.name == 'date') {
                        if (this.endTime != undefined) {
                            item.value = this.startTime + ' 至 ' + this.endTime
                        } else {
                            item.value = ''
                        }
                    }
                })
                this.formData.topArray.map((item, index) => {
                    if (item.name == 'date') {
                        if (item.value == '') {
                            this.formData.topArray.splice(index, 1)
                        }
                    }
                })
                let totalAmount = 0
                let purchaseCount = 0
                this.formData.dataSource = []
                data.records.map(item => {
                    totalAmount += item.totalAmount
                    purchaseCount += item.purchaseCount
                    this.formData.dataSource.push(item)
                })
                this.formData.dataSource.push({
                    date: '合计',
                    totalAmount: totalAmount.toFixed(2),
                    purchaseCount: purchaseCount
                })
            } else if (obj.type == 2) {
                this.formData.topArray.map((item, index) => {
                    if (item.name == 'date') {
                        if (this.endTime != undefined) {
                            item.value = this.startTime + ' 至 ' + this.endTime
                        } else {
                            item.value = ''
                        }
                    }
                })
                this.formData.topArray.map((item, index) => {
                    if (item.name == 'date') {
                        if (item.value == '') {
                            this.formData.topArray.splice(index, 1)
                        }
                    }
                })
                let transactionAmount = 0
                let transactionNumber = 0
                this.formData.dataSource = []
                data.records.map(item => {
                    transactionAmount += item.transactionAmount
                    transactionNumber += Number(item.transactionNumber)
                    this.formData.dataSource.push(item)
                })
                this.formData.dataSource.push({
                    date: '合计',
                    transactionAmount: transactionAmount.toFixed(2),
                    transactionNumber: transactionNumber
                })
            }
        },
        // 利润表
        setprofit(data) {
            this.formData.topArray = []
            this.formData.dataSource = data;
        },
        //库存调拨
        setwarehouse(data) {
            this.formData.topArray.map((item, index) => {
                if (item.name == 'allocateDate') {
                    item.value = data.allocateDate
                } else if (item.name == 'allocateCode') {
                    item.value = data.allocateCode
                } else if (item.name == 'transactorName') {
                    if (this.isEmpty(data.transactorName)) {
                        item.value = '--'
                    } else {
                        item.value = data.transactorName
                    }
                } else if (item.name == 'allocateOutStorageName') {
                    item.value = data.allocateOutStorageName
                } else if (item.name == 'allocateInStorageName') {
                    item.value = data.allocateInStorageName
                } else if (item.name == 'remark') {
                    if (this.isEmpty(data.remark)) {
                        item.value = '--'
                    } else {
                        item.value = data.remark
                    }
                }
            })
            this.formData.bottonArray.map((item, index) => {
                if (item.name == 'distributionMode') {
                    item.value = '物流配送'
                } else if (item.name == 'logisticsCompanyName') {
                    item.value = data.logisticsCompanyName
                }
            })
            this.formData.dataSource = []
            data.itemList.map(item => {
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({})
        },
        //库存报损  其他出库
        setwareloss(data) {
            this.formData.topArray.map((item, index) => {
                if (item.name == 'outboundDate') {
                    item.value = data.outboundDate
                } else if (item.name == 'outboundCode') {
                    item.value = data.outboundCode
                } else if (item.name == 'transactorName') {
                    if (this.isEmpty(data.transactorName)) {
                        item.value = '--'
                    } else {
                        item.value = data.transactorName
                    }
                } else if (item.name == 'storageName') {
                    item.value = data.storageName
                } else if (item.name == 'remark') {
                    if (this.isEmpty(data.remark)) {
                        item.value = '--'
                    } else {
                        item.value = data.remark
                    }
                }
            })
            this.formData.dataSource = []
            let totalAmount = 0
            let productCount = 0
            this.formData.dataSource = []
            data.itemList.map(item => {
                totalAmount += item.totalAmount
                productCount += item.productCount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                productCode: '合计',
                totalAmount: totalAmount,
                productCount: productCount
            })
        },
        //库存报溢  其他入库
        setwareover(data) {
            this.formData.topArray.map((item, index) => {
                if (item.name == 'inboundDate') {
                    item.value = data.inboundDate
                } else if (item.name == 'inboundCode') {
                    item.value = data.inboundCode
                } else if (item.name == 'transactorName') {
                    if (this.isEmpty(data.transactorName)) {
                        item.value = '--'
                    } else {
                        item.value = data.transactorName
                    }
                } else if (item.name == 'storageName') {
                    item.value = data.storageName
                } else if (item.name == 'remark') {
                    if (this.isEmpty(data.remark)) {
                        item.value = '--'
                    } else {
                        item.value = data.remark
                    }
                }
            })
            this.formData.dataSource = []
            let totalAmount = 0
            let productCount = 0
            this.formData.dataSource = []
            data.itemList.map(item => {
                totalAmount += item.totalAmount
                productCount += item.productCount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                productCode: '合计',
                totalAmount: totalAmount,
                productCount: productCount
            })
        },
        //组装拆卸
        setassembly(data) {
            this.formData.topArray.map((item, index) => {
                if (item.name == 'combindDate') {
                    item.value = data.combindDate
                } else if (item.name == 'combindCode') {
                    item.value = data.combindCode
                } else if (item.name == 'transactorName') {
                    if (this.isEmpty(data.transactorName)) {
                        item.value = '--'
                    } else {
                        item.value = data.transactorName
                    }
                } else if (item.name == 'contactCustomerName') {
                    if (this.isEmpty(data.contactCustomerName)) {
                        item.value = '--'
                    } else {
                        item.value = data.contactCustomerName
                    }
                } else if (item.name == 'inboundStorageName') {
                    item.value = data.inboundStorageName
                } else if (item.name == 'remark') {
                    if (this.isEmpty(data.remark)) {
                        item.value = '--'
                    } else {
                        item.value = data.remark
                    }
                }
            })
            this.formData.dataSource = []
            let totalAmount = 0
            let productCount = 0
            let totalAmount1 = 0
            let productCount1 = 0
            this.formData.dataSource = []
            data.itemList.map(item => {
                if (item.behaviorObjType == '1') {
                    this.formData.dataSource.push(item)
                    totalAmount += item.totalAmount
                    productCount += item.needCount
                } else if (item.behaviorObjType == '2') {
                    this.formData.dataSource1.push(item)
                    totalAmount1 += item.totalAmount
                    productCount1 += item.needCount
                }
            })
            this.formData.dataSource.push({
                productCode: '合计',
                totalAmount: totalAmount,
                needCount: productCount
            })
            this.formData.dataSource1.push({
                productCode: '合计',
                totalAmount: totalAmount1,
                needCount: productCount1
            })
        },
        //其他支出
        setotherorder(data) {
            this.formData.topArray.forEach((item) => {
                if (item.name == 'expenditureDate') {
                    item.value = data.otherExpenditureVO.expenditureDate
                } else if (item.name == 'expenditureCode') {
                    item.value = data.otherExpenditureVO.expenditureCode
                } else if (item.name == 'transactorName') {
                    if (this.isEmpty(data.otherExpenditureVO.transactorName)) {
                        item.value = '--'
                    } else {
                        item.value = data.otherExpenditureVO.transactorName
                    }
                } else if (item.name == 'contactCustomerName') {
                    if (this.isEmpty(data.otherExpenditureVO.contactCustomerName)) {
                        item.value = '--'
                    } else {
                        item.value = data.otherExpenditureVO.contactCustomerName
                    }

                } else if (item.name == 'remark') {
                    if (this.isEmpty(data.otherExpenditureVO.remark)) {
                        item.value = '--'
                    } else {
                        item.value = data.otherExpenditureVO.remark
                    }

                }
            })
            this.formData.bottonArray.forEach((item) => {
                if (item.name == 'financeAccountName') {
                    item.value = ''
                    data.otherExpenditurePaymentAccountVO.forEach((item1) => {
                        item.value = item.value + item1.financeAccountName + ','
                    })
                } else if (item.name == 'amount') {
                    item.value = 0
                    data.otherExpenditurePaymentAccountVO.forEach((item1) => {
                        item.value = item.value + item1.amount
                    })
                    item.value = '￥' + item.value
                } else if (item.name == 'otheramount') {
                    item.value = '￥' + data.otherExpenditureVO.amount
                }
            })
            this.formData.dataSource = []
            let totalamount = 0
            data.otherExpenditureItemVOS.forEach((item) => {
                totalamount += item.amount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                financeAccountCode: '合计',
                amount: totalamount
            })
        },
        //其他收入
        setothershouorder(data) {
            this.formData.topArray.forEach((item) => {
                if (item.name == 'voucherDate') {
                    item.value = data.voucherDate
                } else if (item.name == 'code') {
                    item.value = data.code
                } else if (item.name == 'transactorName') {
                    if (this.isEmpty(data.transactorName)) {
                        item.value = '--'
                    } else {
                        item.value = data.transactorName
                    }
                } else if (item.name == 'contactCustomerName') {
                    if (this.isEmpty(data.contactCustomerName)) {
                        item.value = '--'
                    } else {
                        item.value = data.contactCustomerName
                    }

                } else if (item.name == 'remark') {
                    if (this.isEmpty(data.remark)) {
                        item.value = '--'
                    } else {
                        item.value = data.remark
                    }

                }
            })
            this.formData.bottonArray.forEach((item) => {
                if (item.name == 'financeAccountName') {
                    item.value = ''
                    data.financeOtherIncomeCollectionAccountVOList.forEach((item1) => {
                        item.value = item.value + item1.financeAccountName + ','
                    })
                    item.value.charAt(item.value.length - 1) == ',' ? item.value = item.value.substring(0, item.value.length - 1) : ''
                } else if (item.name == 'amount') {
                    item.value = 0
                    data.financeOtherIncomeCollectionAccountVOList.forEach((item1) => {
                        item.value = item.value + item1.amount
                    })
                    item.value = '￥' + item.value
                } else if (item.name == 'otheramount') {
                    item.value = '￥' + data.collectionTotalAmount
                }
            })
            this.formData.dataSource = []
            let totalamount = 0
            data.financeOtherIncomeItemVOList.forEach((item) => {
                totalamount += item.amount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                otherIncomeCode: '合计',
                amount: totalamount
            })
        },
        //收款单
        setshouorder(data) {
            this.formData.topArray.forEach((item) => {
                if (item.name == 'voucherDate') {
                    item.value = data.voucherDate
                } else if (item.name == 'code') {
                    item.value = data.code
                } else if (item.name == 'transactorName') {
                    if (this.isEmpty(data.transactorName)) {
                        item.value = '--'
                    } else {
                        item.value = data.transactorName
                    }
                } else if (item.name == 'contactCustomerName') {
                    if (this.isEmpty(data.contactCustomerName)) {
                        item.value = '--'
                    } else {
                        item.value = data.contactCustomerName
                    }

                } else if (item.name == 'remark') {
                    if (this.isEmpty(data.remark)) {
                        item.value = '--'
                    } else {
                        item.value = data.remark
                    }

                }
            })
            this.formData.bottonArray.forEach((item) => {
                if (item.name == 'discountAmount') {
                    item.value = '￥' + data.discountAmount
                } else if (item.name == 'totalPayableAmount') {
                    item.value = '￥' + data.totalPayableAmount
                }
            })
            this.formData.dataSource = []
            let totalamount = 0
            data.financeCollectionOrderPayVOList.forEach((item) => {
                totalamount += item.amount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                otherIncomeCode: '合计',
                amount: totalamount
            })
        },
        //付款单
        setfuorder(data) {
            this.formData.topArray.forEach((item) => {
                if (item.name == 'orderDate') {
                    item.value = data.financePaymentOrder.orderDate
                } else if (item.name == 'code') {
                    item.value = data.financePaymentOrder.code
                } else if (item.name == 'transactorName') {
                    if (this.isEmpty(data.financePaymentOrder.transactorName)) {
                        item.value = '--'
                    } else {
                        item.value = data.financePaymentOrder.transactorName
                    }
                } else if (item.name == 'contactCustomerName') {
                    if (this.isEmpty(data.financePaymentOrder.contactCustomerName)) {
                        item.value = '--'
                    } else {
                        item.value = data.financePaymentOrder.contactCustomerName
                    }

                } else if (item.name == 'remark') {
                    if (this.isEmpty(data.financePaymentOrder.remark)) {
                        item.value = '--'
                    } else {
                        item.value = data.financePaymentOrder.remark
                    }

                }
            })
            this.formData.bottonArray.forEach((item) => {
                if (item.name == 'discountAmount') {
                    item.value = '￥' + data.financePaymentOrder.discountAmount
                } else if (item.name == 'totalAmount') {
                    item.value = '￥' + data.financePaymentOrder.totalAmount
                }
            })
            this.formData.dataSource = []
            let totalamount = 0
            data.financePaymentOrderPay.forEach((item) => {
                totalamount += item.amount
                this.formData.dataSource.push(item)
            })
            this.formData.dataSource.push({
                financeAccountCode: '合计',
                amount: totalamount
            })
        },
    }
}